import { useCallback, useEffect } from 'react';
import { Skeleton, Table } from 'antd';
import throttle from 'lodash/throttle';

import styled from 'styled-components';

export const TableSkeleton = styled(Skeleton.Input)`
    width: 100%;
    .ant-skeleton-input {
        min-width: unset;
        height: ${({ $height = '22px' }) => $height};
    }
`;

export const infiniteColumns = (columns, height) => {
    return columns.map((column) => {
        if ([Table.EXPAND_COLUMN, Table.SELECTION_COLUMN].includes(column))
            return column;
        return {
            ...column,
            render: (text, record, index) => {
                if (record.placeholder) {
                    return (
                        <TableSkeleton
                            size="small"
                            $height={height}
                            active
                            block
                        />
                    );
                } else
                    return column.render
                        ? column.render(text, record, index)
                        : text;
            },
        };
    });
};

export const infiniteData = (data, isLoading, count) => {
    if (isLoading) {
        return [
            ...data,
            ...Array.from({ length: count }, (_, i) => ({
                key: `placeholder${i}`,
                placeholder: true,
            })),
        ];
    }
    return data;
};

export const useInfiniteScroll = (tableRef, offset, cb) => {
    const throttledCb = useCallback(
        throttle(() => {
            cb();
        }, 1000),
        [cb]
    );

    const handleScroll = ({ target }) => {
        const maxScroll = target.scrollHeight - target.clientHeight;
        const currentScroll = target.scrollTop;

        if (maxScroll - currentScroll < offset) {
            throttledCb();
        }
    };
    useEffect(() => {
        const tbody = tableRef?.current.querySelector('.ant-table-body');
        if (tbody) tbody.addEventListener('scroll', handleScroll);

        return () => tbody && tbody.removeEventListener('scroll', handleScroll);
    });
};
